import { Button, Form, Input } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useWatch } from "antd/lib/form/Form";
import KnowledgeUploader from "./KnowledgeUploader";
import { useOSSFileUrl } from "./useOSSFileUrl";

export default function FileInput({
    form,
    labelPre,
    prefix = [],
    fullPrefix = [],
    namePre,
    type,
    pathName,
    onChange,
    accept,
}: any) {
    const { init, getVisitUrl } = useOSSFileUrl();
    const [OSSData, setOSSData] = useState<any>(null);
    const pathInputName = pathName ? pathName : namePre ? `${namePre}Url` : "url";
    const fileInputName = namePre ? `${namePre}File` : "file";
    const fileList = useWatch([...fullPrefix, fileInputName], form);

    // 初始化OSS数据
    useEffect(() => {
        const initializeOSS = async () => {
            const data = await init(type);
            setOSSData(data);
        };
        initializeOSS();
    }, []);

    useEffect(() => {
        const initializeFile = async () => {
            const fieldValue = form.getFieldValue([...fullPrefix, pathInputName]);
            if (!fieldValue) return;
            const path = await getVisitUrl(fieldValue);
            const file = form.getFieldValue([...fullPrefix, fileInputName]);
            if (file || !path) return;
            // 只用于初始化file，所以file存在时不做处理
            if (file || !path) return;
            const fileName = fieldValue.substring(fieldValue.lastIndexOf("/") + 1);
            const list: any = [{ name: fileName, url: path, uid: -(new Date()).getTime(), status: "done" }];
            form.setFieldValue([...fullPrefix, fileInputName], list);
        };
        initializeFile();
    }, []);

    const handleFileChange = async (fileList: any) => {
        if (!fileList || !Array.isArray(fileList) || fileList.length === 0) {
            form.setFieldValue([...fullPrefix, pathInputName], undefined);
            return;
        }
        const file = fileList[fileList.length - 1];
        const url = await getVisitUrl(file?.url);
        form.setFieldValue([...fullPrefix, pathInputName], file?.url || "");
        if (file?.status === "done") {
            const fileName = file?.url.substring(file?.url.lastIndexOf("/") + 1);
            const list: any = [{ name: fileName, url: url, uid: -(new Date()).getTime() }];
            form.setFieldValue([...fullPrefix, fileInputName], list);
            onChange && onChange(list[0]);
        }
    };

    return <>
        <Form.Item label={`${labelPre}文件`}
            name={[...prefix, fileInputName]} rules={[{ required: true, message: '不能为空' }]}>
            <KnowledgeUploader type={type} maxCount={1} ossData={OSSData}
                onChange={handleFileChange} accept={accept}>
                {((fileList || []).length === 0) &&
                    <Button icon={<UploadOutlined />}>点击上传</Button>}
            </KnowledgeUploader>
        </Form.Item>
        <Form.Item hidden label={`${labelPre}文件地址`} name={[...prefix, pathInputName]}>
            <Input />
        </Form.Item>
    </>;
}